<template>
  <div>
    <p>{{ $t('text.loggedOut')}}</p>
    <v-btn @click.prevent="closeWindow()">{{ $t('button.close')}}</v-btn>
  </div>
</template>

<script>
export default {
  name: "neoparent-logged-out",
  mounted() {
    close()
    window.location.href = 'https://www.mothchi.eu/'
  },
  methods: {
    closeWindow() {
      window.close()
      window.location.href = 'https://www.mothchi.eu/'
    }
  }
}
</script>

<style scoped>

</style>
